<template>
  <Modal ref="modal" class="modal-inquiry-transfer" :actions="actions" @action="handleAction" immediate>
    <h1>Fall umteilen</h1>
    <p>Wollen Sie den Fall wirklich umteilen?<br/>
      Der Fall ist danach für Sie nicht mehr sichtbar.</p>
    <form>
      <div class="group">
        <Select
          v-if="branches.length > 1"
          fill
          label="SPD"
          :searchable="true"
          :options="branches"
          :value.sync="branch"
        />
      </div>
      <div class="group" v-if="notOwnBranch">
        <div class="info" >
          <Icon name="info" />
          Schweigepflichtentbindung erforderlich
        </div>
      </div>
      <div class="group" v-if="!notOwnBranch">
        <Select
          fill
          :disabled="notOwnBranch"
          label="Psycholog:in"
          :searchable="true"
          :options="psychologists"
          :value.sync="psychologist"
        />
      </div>
    </form>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';
  import Select from '@/components/ui/inputs/Select';
  import { Store } from '@/store';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ModalInquiryTransfer',
    components: {
      Icon,
      Select,
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uuid: {
        type: String,
        default: null,
      },
      isAssigned: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        psychologists: [],
        branches: [],
        psychologist: null,
        branch: Store.branch?.uuid,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'cancel', label: i18n.t('labels.cancel') },
          { value: 'transfer', label: i18n.t('labels.transfer') },
        ];
      },
      notOwnBranch() {
        return this.branch !== Store.branch?.uuid;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      branch(value) {
        if (value !== Store.branch?.uuid) {
          this.psychologist = null;
        }
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    async created() {
      const branches = await this.$sav.api.get('/branches');
      this.branches = branches.map(branch => ({ value: branch.uuid, label: branch.name }));

      const users = await this.$sav.api.get('/users/psychologists');
      let psychologists = users.map(user => ({ value: user.uuid, label: user.name }));
      if (this.isAssigned && Store.role !== 'spd_manager') {
        psychologists = psychologists.filter(u => u.value !== Store.uuid);
      }
      this.psychologists = psychologists;
    },
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        if (action === 'transfer') {
          const uuid = this.uuid;
          const branch = this.branch;
          const psychologist = this.psychologist;
          const response = await this.$sav.api.post('/inquiry/transfer', null, {
            uuid,
            branch,
            psychologist,
          });
          if (response) {
            this.$emit('done');
          }
        }
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-inquiry-transfer {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }

      & > div.info {
        position: relative;
        padding: 8px 8px 8px 42px;
        border: 1px solid $color-blue-solid-100;
        border-radius: 4px;
        box-shadow: $box-shadow-1;
        color: $color-blue-solid-100;
        svg {
          top: 50%;
          left: 8px;
          transform: translate(0, -50%);
          position: absolute;
          width: 20px;
          height: 20px;
        }
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
